"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const exchange_1 = require("@framework/exchange");
const types_1 = require("@framework/types");
const MysteryBoxContent = props => {
    const { mysteryBox } = props;
    if (!mysteryBox) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: mysteryBox.content?.components.map(component => ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 4 }, children: component.tokenType }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 4 }, children: component.tokenType !== types_1.TokenType.ERC20 ? ((0, jsx_runtime_1.jsx)(material_1.Link, { component: react_router_dom_1.Link, to: `/${component.tokenType.toLowerCase()}/templates/${component.templateId || 0}`, children: component.template.title })) : (component.template.title) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: { xs: 4 }, children: (0, exchange_1.formatEther)(component.amount, component.contract.decimals, "") })] }, component.id))) }));
};
exports.MysteryBoxContent = MysteryBoxContent;
//# sourceMappingURL=mysterybox-content.js.map